import { useEffect, useReducer, useRef } from 'react';

const PENDING = 'PENDING';
const READY = 'READY';
const ERROR = 'ERROR';

const initialState = {
  data: null,
  error: null,
};

function reducer(state, action) {
  if (action.type === ERROR) {
    return {
      ...state,
      data: null,
      error: action.error,
    };
  } else if (action.type === READY) {
    return {
      ...state,
      data: action.data,
      error: null,
    };
  }

  return {
    ...state,
    data: null,
    error: null,
  };
}

export function useObservable(observable) {
  const [state, dispatch] = useReducer(reducer, initialState);

  // we want to persist the subscription during the lifecycle of the component
  const subscription = useRef(null);

  function unsubscribe() {
    dispatch({ type: PENDING });
    if (subscription.current) {
      subscription.current.unsubscribe();
      subscription.current = null;
    }
  }

  function handleData(data) {
    dispatch({
      type: READY,
      data,
    });
  }

  function handleError(error) {
    dispatch({
      type: ERROR,
      error,
    });
  }

  useEffect(() => {
    // bind to observable
    if (observable) {
      subscription.current = observable.subscribe({
        next: handleData,
        error: handleError,
      });
    } else {
      unsubscribe();
    }

    return () => {
      unsubscribe();
    };
  }, [observable]);

  return state;
}

